import httpService from "../../components/service";
// import Vue from 'vue'

export const search = {
    namespaced: true,
    state: {
        items: [],
        length: 0,
        meta: {},
        query: {}
    },
    getters: {
        getAllResults: state => {
            return state.items;
        },
        getResults: (state, getters) => length => {
            if (length === "all") {
                return this.getAllResults();
            } else {
                return Object.entries(state.items)
                    .slice(0, length)
                    .map(entry => entry[1]);
            }
        },
        getResultsLength: (state, getters) => {
            return state.length;
        },
        getMeta: state => {
            return state.meta;
        },
        getMetaTotal: state => {
            return state.meta.total;
        },
        getMetaTotalPage: state => {
            return state.meta.totalPage;
        },
        getQuery: (state, getters) => {
            return state.query;
        }
    },
    mutations: {
        GETRESULTS_SEARCH(state, data) {
            state.items = data.items;
            state.length = data.length;
            state.meta = data.meta;
        },
        SET_QUERY(state, data) {
            state.query = data;
        }
    },
    actions: {
        setQuery: (context, data) => {
            return new Promise((resolve, reject) => {
                if (typeof data.search.search !== "undefined") {
                    context.commit("SET_QUERY", data.search.search);
                    resolve();
                }
            });
        },
        getResults: (context, data) => {
            return new Promise((resolve, reject) => {
                let queryString = "?limit=20";
                if (typeof data !== "undefined" && typeof data.routeParams !== "undefined" && !!Object.entries(data.routeParams).length) {
                    queryString += "&";
                    for (let key in data.routeParams) {
                        if (queryString !== "?limit=20&") {
                            queryString += "&";
                        }
                        queryString += key + "=" + data.routeParams[key];
                    }
                }
                if (typeof context !== "undefined") {
                    if (data.routeParams && data.routeParams.standDesign) {
                        httpService.getWithoutCampaign("/components" + queryString).then(data => {
                            let items = {};
                            if (typeof data !== "undefined" && data !== null && data.hasOwnProperty("data")) {
                                for (let item of data.data) {
                                    items[item.id] = item;
                                }
                            }
                            if (typeof data !== "undefined" && typeof context !== "undefined") {
                                context.commit("GETRESULTS_SEARCH", { items: items, length: data.length, meta: data.meta });
                                resolve();
                            }
                        });
                    } else {
                        httpService.get("/components" + queryString).then(data => {
                            let items = {};
                            if (typeof data !== "undefined" && data !== null && data.hasOwnProperty("data")) {
                                for (let item of data.data) {
                                    items[item.id] = item;
                                }
                            }
                            if (typeof data !== "undefined" && typeof context !== "undefined") {
                                context.commit("GETRESULTS_SEARCH", { items: items, length: data.length, meta: data.meta });
                                resolve();
                            }
                        });
                    }
                }
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/catalog/search.js